<template>
	<router-link
		class="event-speaker-card__speaker"
		:to="{
			name: 'speaker-by-id',
			params: {
				id: speaker.speaker_id,
			},
		}"
		v-bind:style="{ background: cardBackground }"
	>
		<Avatar
			class="event-speaker-card__speaker-avatar"
			:size="60"
			:avatar="speaker.speaker_logo"
		/>
		<div>
			<p class="event-speaker-card__speaker-name">
				{{ speaker.speaker_name }}
			</p>
			<p class="event-speaker-card__speaker-title">
				{{ speaker.speaker_title }}
			</p>
		</div>
	</router-link>
</template>
<script>
import Avatar from '@/components/Avatar'

export default {
	components: {
		Avatar,
	},
	props: {
		speaker: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		cardBackground() {
			return this.$route.name === 'event-speakers' ? '#fff' : '#F3F3F6'
		},
	},
}
</script>
<style lang="scss">
.event-speaker-card {
	&__speaker {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		padding: 12px;
		border: 1px solid #e2e2e2;
		border-radius: 12px;
		margin-bottom: 8px;
		text-decoration: none;

		&-avatar {
			margin-right: 12px;
			border-radius: 8px;
		}

		&-name {
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			margin: 0 !important;
			color: var(--accent-color);
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			flex-grow: 1;
		}
		&-title {
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a;
			margin-top: 4px;
		}

		&-icon {
			color: #9b9b9b !important;
		}
	}
}
</style>
